import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class InformersService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'open';

  getText(id,days): Observable<string> {
    // check and set params of pagination
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + `/informer/${id}/${days}`;
    const headers = new HttpHeaders()
      .set('accept', '*/*');
    return this._http.get<string>(uri, {headers: headers});
  }
}
